/**
 * Catálogo de los 34 procesos de simplificación fonológica (E1–E8 estructurales,
 * A1–A10 asimilación, S1–S16 sustitución). Referencia de PRESENTACIÓN para el
 * filtro/etiquetas del Banco de Palabras.
 *
 * Fuente clínica ÚNICA: docs/peff/PEFF_MASTER_ESPECIFICACION.md §4.2 (hoja PSF).
 * Los códigos también los emite el motor M1 (phonology-engine/classify.ts). Si la
 * especificación maestra cambia, actualizar aquí. NO es el catálogo viejo de 17.
 */

export type CategoriaProceso = "estructural" | "asimilacion" | "sustitucion";

export interface ProcesoFonologico {
  codigo: string;
  nombre: string;
  categoria: CategoriaProceso;
}

export const CATALOGO_PROCESOS: readonly ProcesoFonologico[] = [
  // E1–E8 — estructurales
  { codigo: "E1", nombre: "Reducción del grupo consonántico", categoria: "estructural" },
  { codigo: "E2", nombre: "Reducción de diptongo", categoria: "estructural" },
  { codigo: "E3", nombre: "Omisión de coda silábica", categoria: "estructural" },
  { codigo: "E4", nombre: "Coalescencia", categoria: "estructural" },
  { codigo: "E5", nombre: "Omisión de elementos átonos", categoria: "estructural" },
  { codigo: "E6", nombre: "Omisión de sílaba tónica", categoria: "estructural" },
  { codigo: "E7", nombre: "Adición (prótesis/epéntesis)", categoria: "estructural" },
  { codigo: "E8", nombre: "Metátesis", categoria: "estructural" },
  // A1–A10 — asimilación
  { codigo: "A1", nombre: "Asimilación idéntica", categoria: "asimilacion" },
  { codigo: "A2", nombre: "Asimilación labial", categoria: "asimilacion" },
  { codigo: "A3", nombre: "Asimilación dental", categoria: "asimilacion" },
  { codigo: "A4", nombre: "Asimilación alveolar", categoria: "asimilacion" },
  { codigo: "A5", nombre: "Asimilación palatal", categoria: "asimilacion" },
  { codigo: "A6", nombre: "Asimilación velar", categoria: "asimilacion" },
  { codigo: "A7", nombre: "Asimilación a líquidos", categoria: "asimilacion" },
  { codigo: "A8", nombre: "Asimilación nasal", categoria: "asimilacion" },
  { codigo: "A9", nombre: "Asimilación vocálica", categoria: "asimilacion" },
  { codigo: "A10", nombre: "Asimilación silábica/duplicación", categoria: "asimilacion" },
  // S1–S16 — sustitución
  { codigo: "S1", nombre: "Aspiración de trabante", categoria: "sustitucion" },
  { codigo: "S2", nombre: "Posteriorización", categoria: "sustitucion" },
  { codigo: "S3", nombre: "Frontalización", categoria: "sustitucion" },
  { codigo: "S4", nombre: "Labialización", categoria: "sustitucion" },
  { codigo: "S5", nombre: "Oclusivización", categoria: "sustitucion" },
  { codigo: "S6", nombre: "Fricativización", categoria: "sustitucion" },
  { codigo: "S7", nombre: "Fricativos entre sí", categoria: "sustitucion" },
  { codigo: "S8", nombre: "Sonorización", categoria: "sustitucion" },
  { codigo: "S9", nombre: "Ensordecimiento", categoria: "sustitucion" },
  { codigo: "S10", nombre: "Semiconsonantización de líquidos", categoria: "sustitucion" },
  { codigo: "S11", nombre: "Líquidos entre sí", categoria: "sustitucion" },
  { codigo: "S12", nombre: "Líquidos por no líquidos", categoria: "sustitucion" },
  { codigo: "S13", nombre: "No líquidos por líquidos", categoria: "sustitucion" },
  { codigo: "S14", nombre: "Nasalización", categoria: "sustitucion" },
  { codigo: "S15", nombre: "Oralización de nasales", categoria: "sustitucion" },
  { codigo: "S16", nombre: "Sustitución de vocales", categoria: "sustitucion" },
];

export const CATEGORIA_LABEL: Record<CategoriaProceso, string> = {
  estructural: "Estructurales (E)",
  asimilacion: "Asimilación (A)",
  sustitucion: "Sustitución (S)",
};

const POR_CODIGO = new Map(CATALOGO_PROCESOS.map((p) => [p.codigo, p]));

/** Etiqueta legible para un código: "S10 · Semiconsonantización…" o el código crudo. */
export function nombreProceso(codigo: string | null): string {
  if (!codigo) return "—";
  const p = POR_CODIGO.get(codigo);
  return p ? `${p.codigo} · ${p.nombre}` : codigo;
}
